import { Corte } from "src/gql/schema"
import { CrearCorteRes } from "src/pages/Cortes/interfaces/CrearCorteRes"
import corteDiaOpener from "src/shared/openers/corteDiaOpener"
import { RenderSnackbarProps } from "src/shared/hooks/useSnackbar"
import { CerrarCorteFn } from "./cerrarCorte"

export interface HandleAdminCerrarTurnoParams {
    isUltimoCorte?: boolean
    corteSelected?: Corte
    variables: Record<string, any>
    isRolConCierreAutomatico: boolean
    crearCorte: (
        variables: Record<string, any>,
        onSuccess?: (data?: CrearCorteRes) => void,
        onError?: (error?: any) => void,
        onFinally?: () => void
    ) => void
    cerrarCorte: CerrarCorteFn
    cambiarTurno: () => void
    setSuccessData: (data: any) => void
    onSuccessNewCorte: (params: { folio: string; corte_id: string }) => void
    showSnackbar: (params: RenderSnackbarProps) => void
    setOpenImpresion: (value: boolean) => void
    setisCerrarCorteLoading: (value: boolean) => void
    setdisableButtons: (value: boolean) => void
}

// Admin/gerente/superadmin cuando el botón presionado es "Hacer corte y cerrar turno"
export const handleAdminCerrarTurno = ({
    isUltimoCorte,
    corteSelected,
    variables,
    isRolConCierreAutomatico,
    crearCorte,
    cerrarCorte,
    cambiarTurno,
    setSuccessData,
    onSuccessNewCorte,
    showSnackbar,
    setOpenImpresion,
    setisCerrarCorteLoading,
    setdisableButtons,
}: HandleAdminCerrarTurnoParams): void => {
    // Ya existe un corte pendiente por cerrar (viene de la tabla de cortes): solo se cierra
    if (!isUltimoCorte) {
        cerrarCorte({
            corte_id: corteSelected?.corte_id,
            folio: String(corteSelected?.folio || ""),
        }).finally(() => {
            setisCerrarCorteLoading(false)
            setdisableButtons(false)
            setOpenImpresion(false)
            corteDiaOpener({
                stateNuevoCorteTurno: {
                    corte_id: corteSelected?.corte_id || "",
                },
            })
        })
        return
    }

    // Es el último corte: se crea uno nuevo, se cierra el turno y, si el rol lo permite, se cierra automáticamente
    crearCorte(
        variables,
        (data) => {
            setSuccessData(data)
            cambiarTurno()

            if (isRolConCierreAutomatico) {
                cerrarCorte({
                    corte_id: data?.corte_id,
                    folio: String(data?.folio || ""),
                }).finally(() => {
                    setisCerrarCorteLoading(false)
                    setdisableButtons(false)
                    setOpenImpresion(false)
                })
            }

            onSuccessNewCorte({
                folio: String(data?.folio || ""),
                corte_id: data?.corte_id || "",
            })
        },
        (error) => {
            console.log("error, ", error)
            showSnackbar({
                title: "Error al crear corte",
                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                status: "error",
            })
        },
        () => {
            setisCerrarCorteLoading(false)
            setdisableButtons(false)
            if (!isRolConCierreAutomatico) {
                setOpenImpresion(false)
            }
        }
    )
}
